<template>
  <div class="location">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Job Salary</h4>
        <br />

        <h6 class="mb-3 font-weight-bold text-left mt-4">Salary Amount (per month)</h6>

        <a-input-group compact class="text-left" size="large">
          <a-select v-model="currency" default-value="USD">
            <a-select-option value="USD">USD</a-select-option>
            <!-- <a-select-option value="NGN">NGN</a-select-option>
            <a-select-option value="EUR">EUR</a-select-option> -->
          </a-select>
          <a-input-number
            :precision="number"
            style="width: 50%"
            size="large"
            placeholder="500 , 1000"
            v-model="budget"
          />
        </a-input-group>

        <br />

        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "job-salary",
  data() {
    return {
      currencies: ["USD", "NGN", "GBP"],
      budget: this.$store.state.fcjob.fcjobData.budget,
      currency: this.$store.state.fcjob.fcjobData.currency
        ? this.$store.state.fcjob.fcjobData.currency
        : "USD"
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { budget, currency } = this;
      this.$store.commit("fcjob/updateFcJob", {
        budget,
        currency
      });
      this.$router.push("company-bio");
    },
    skip() {
      this.$router.push("company-bio");
    }
  },
  mounted() {}
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
